import React from 'react'

export default function CheckMarkIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M5.18366 8.68341L9.29616 4.57091L8.47949 3.75425L5.18366 7.05008L3.52116 5.38758L2.70449 6.20425L5.18366 8.68341ZM6.00033 11.8334C5.19338 11.8334 4.43505 11.6803 3.72533 11.374C3.0156 11.0678 2.39824 10.6522 1.87324 10.1272C1.34824 9.60217 0.932617 8.9848 0.626367 8.27508C0.320117 7.56536 0.166992 6.80703 0.166992 6.00008C0.166992 5.19314 0.320117 4.4348 0.626367 3.72508C0.932617 3.01536 1.34824 2.398 1.87324 1.873C2.39824 1.348 3.0156 0.932373 3.72533 0.626123C4.43505 0.319873 5.19338 0.166748 6.00033 0.166748C6.80727 0.166748 7.5656 0.319873 8.27533 0.626123C8.98505 0.932373 9.60241 1.348 10.1274 1.873C10.6524 2.398 11.068 3.01536 11.3743 3.72508C11.6805 4.4348 11.8337 5.19314 11.8337 6.00008C11.8337 6.80703 11.6805 7.56536 11.3743 8.27508C11.068 8.9848 10.6524 9.60217 10.1274 10.1272C9.60241 10.6522 8.98505 11.0678 8.27533 11.374C7.5656 11.6803 6.80727 11.8334 6.00033 11.8334Z'
        fill='currentcolor'
      />
    </svg>
  )
}
